// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* =========================================
   MEDIA MANAGER (Képek, PDF-ek, Fájlfeltöltés)
   ========================================= */

/* --- KÉPFELTÖLTÉS KONTÉNEREK ÉS DROPZONE --- */
.szakjelentes-create-wrapper .image-upload-container {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
}

.szakjelentes-create-wrapper .dropzone {
    border: 2px dashed #ccc;
    border-radius: 4px;
    padding: 16px;
    text-align: center;
    cursor: pointer;
    margin-bottom: 10px;
}

.szakjelentes-create-wrapper .dropzone p {
    margin: 0;
    font-size: 1em;
    color: #888;
}

.szakjelentes-create-wrapper .dropzone.active {
    border-color: #2196f3;
}

/* --- FELTÖLTÖTT KÉPEK MEGJELENÍTÉSE --- */
.szakjelentes-create-wrapper .uploaded-image {
    position: relative;
    display: flex;
    align-items: center;
    padding: 8px;
    border: 1px solid #ccc;
    border-radius: 4px;
    margin-top: 10px;
    background-color: #f9f9f9;
}

.szakjelentes-create-wrapper .uploaded-image img {
    max-width: 80%;
    height: auto;
    object-fit: cover;
    border-radius: 4px;
    cursor: pointer;
}

.szakjelentes-create-wrapper .delete-image-button {
    background-color: #ff4d4d;
    color: white;
    border: none;
    cursor: pointer;
    font-size: 24px;
    width: 10%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left: 10px;
    border-radius: 4px;
    transition: background-color 0.3s ease;
}

.szakjelentes-create-wrapper .delete-image-button:hover {
    background-color: #d32f2f;
}

.szakjelentes-create-wrapper .image-preview {
    margin-top: 20px;
}

.szakjelentes-create-wrapper .image-preview img {
    max-width: 100%;
    border-radius: 5px;
}

/* --- KÉP MEGJELENÍTŐ MODAL (NAGYÍTÁS) --- */
.szakjelentes-create-wrapper .image-modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.75);
    z-index: 999;
}

.szakjelentes-create-wrapper .image-modal {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background-color: #fff;
    padding: 20px;
    border-radius: 8px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    max-width: 80%;
    max-height: 80%;
    z-index: 1000;
    outline: none;
}

.szakjelentes-create-wrapper .modal-image {
    max-width: 100%;
    height: 100%;
    border-radius: 8px;
}

.szakjelentes-create-wrapper .modal-close-button {
    position: absolute;
    top: 10px;
    right: 10px;
    background-color: #ff4d4d;
    color: #fff;
    border: none;
    border-radius: 50%;
    width: 30px;
    height: 30px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: background-color 0.3s ease;
}

.szakjelentes-create-wrapper .modal-close-button:hover {
    background-color: #d32f2f;
}

/* --- PDF KEZELÉS --- */
.szakjelentes-create-wrapper .attached-pdfs {
    margin-top: 30px;
}

.szakjelentes-create-wrapper .attached-pdfs h3 {
    margin-bottom: 10px;
}

.szakjelentes-create-wrapper .pdf-item {
    display: flex;
    align-items: center;
    padding: 10px;
    border: 1px solid rgba(0, 0, 0, 0.1);
    border-radius: 5px;
    margin: 5px 0;
    cursor: pointer;
    background-color: #ffffff;
    transition: background-color 0.3s ease;
}

.szakjelentes-create-wrapper .pdf-item:hover {
    background-color: #f1f1f1;
}

.szakjelentes-create-wrapper .pdf-icon {
    margin-right: 10px;
    font-size: 1.5rem;
    color: red;
}

.szakjelentes-create-wrapper .pdf-filename {
    flex-grow: 1;
    word-wrap: break-word;
}`, "",{"version":3,"sources":["webpack://./src/components/szakjelentesCreate/MediaManager.css"],"names":[],"mappings":"AAAA;;8CAE8C;;AAE9C,gDAAgD;AAChD;IACI,aAAa;IACb,eAAe;IACf,SAAS;AACb;;AAEA;IACI,uBAAuB;IACvB,kBAAkB;IAClB,aAAa;IACb,kBAAkB;IAClB,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,SAAS;IACT,cAAc;IACd,WAAW;AACf;;AAEA;IACI,qBAAqB;AACzB;;AAEA,2CAA2C;AAC3C;IACI,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,cAAc;IACd,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,eAAe;IACf,UAAU;IACV,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,iBAAiB;IACjB,kBAAkB;IAClB,sCAAsC;AAC1C;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,kBAAkB;AACtB;;AAEA,6CAA6C;AAC7C;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,qCAAqC;IACrC,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,sBAAsB;IACtB,aAAa;IACb,kBAAkB;IAClB,wCAAwC;IACxC,cAAc;IACd,eAAe;IACf,aAAa;IACb,aAAa;AACjB;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,yBAAyB;IACzB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,sCAAsC;AAC1C;;AAEA;IACI,yBAAyB;AAC7B;;AAEA,wBAAwB;AACxB;IACI,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,aAAa;IACb,oCAAoC;IACpC,kBAAkB;IAClB,aAAa;IACb,eAAe;IACf,yBAAyB;IACzB,sCAAsC;AAC1C;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,UAAU;AACd;;AAEA;IACI,YAAY;IACZ,qBAAqB;AACzB","sourcesContent":["/* =========================================\n   MEDIA MANAGER (Képek, PDF-ek, Fájlfeltöltés)\n   ========================================= */\n\n/* --- KÉPFELTÖLTÉS KONTÉNEREK ÉS DROPZONE --- */\n.szakjelentes-create-wrapper .image-upload-container {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 10px;\n}\n\n.szakjelentes-create-wrapper .dropzone {\n    border: 2px dashed #ccc;\n    border-radius: 4px;\n    padding: 16px;\n    text-align: center;\n    cursor: pointer;\n    margin-bottom: 10px;\n}\n\n.szakjelentes-create-wrapper .dropzone p {\n    margin: 0;\n    font-size: 1em;\n    color: #888;\n}\n\n.szakjelentes-create-wrapper .dropzone.active {\n    border-color: #2196f3;\n}\n\n/* --- FELTÖLTÖTT KÉPEK MEGJELENÍTÉSE --- */\n.szakjelentes-create-wrapper .uploaded-image {\n    position: relative;\n    display: flex;\n    align-items: center;\n    padding: 8px;\n    border: 1px solid #ccc;\n    border-radius: 4px;\n    margin-top: 10px;\n    background-color: #f9f9f9;\n}\n\n.szakjelentes-create-wrapper .uploaded-image img {\n    max-width: 80%;\n    height: auto;\n    object-fit: cover;\n    border-radius: 4px;\n    cursor: pointer;\n}\n\n.szakjelentes-create-wrapper .delete-image-button {\n    background-color: #ff4d4d;\n    color: white;\n    border: none;\n    cursor: pointer;\n    font-size: 24px;\n    width: 10%;\n    height: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin-left: 10px;\n    border-radius: 4px;\n    transition: background-color 0.3s ease;\n}\n\n.szakjelentes-create-wrapper .delete-image-button:hover {\n    background-color: #d32f2f;\n}\n\n.szakjelentes-create-wrapper .image-preview {\n    margin-top: 20px;\n}\n\n.szakjelentes-create-wrapper .image-preview img {\n    max-width: 100%;\n    border-radius: 5px;\n}\n\n/* --- KÉP MEGJELENÍTŐ MODAL (NAGYÍTÁS) --- */\n.szakjelentes-create-wrapper .image-modal-overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background-color: rgba(0, 0, 0, 0.75);\n    z-index: 999;\n}\n\n.szakjelentes-create-wrapper .image-modal {\n    position: fixed;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    background-color: #fff;\n    padding: 20px;\n    border-radius: 8px;\n    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n    max-width: 80%;\n    max-height: 80%;\n    z-index: 1000;\n    outline: none;\n}\n\n.szakjelentes-create-wrapper .modal-image {\n    max-width: 100%;\n    height: 100%;\n    border-radius: 8px;\n}\n\n.szakjelentes-create-wrapper .modal-close-button {\n    position: absolute;\n    top: 10px;\n    right: 10px;\n    background-color: #ff4d4d;\n    color: #fff;\n    border: none;\n    border-radius: 50%;\n    width: 30px;\n    height: 30px;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    transition: background-color 0.3s ease;\n}\n\n.szakjelentes-create-wrapper .modal-close-button:hover {\n    background-color: #d32f2f;\n}\n\n/* --- PDF KEZELÉS --- */\n.szakjelentes-create-wrapper .attached-pdfs {\n    margin-top: 30px;\n}\n\n.szakjelentes-create-wrapper .attached-pdfs h3 {\n    margin-bottom: 10px;\n}\n\n.szakjelentes-create-wrapper .pdf-item {\n    display: flex;\n    align-items: center;\n    padding: 10px;\n    border: 1px solid rgba(0, 0, 0, 0.1);\n    border-radius: 5px;\n    margin: 5px 0;\n    cursor: pointer;\n    background-color: #ffffff;\n    transition: background-color 0.3s ease;\n}\n\n.szakjelentes-create-wrapper .pdf-item:hover {\n    background-color: #f1f1f1;\n}\n\n.szakjelentes-create-wrapper .pdf-icon {\n    margin-right: 10px;\n    font-size: 1.5rem;\n    color: red;\n}\n\n.szakjelentes-create-wrapper .pdf-filename {\n    flex-grow: 1;\n    word-wrap: break-word;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
